import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Korean() {
  return (
    <ApiCommunityDirectoryPage
      community="Korean"
      eyebrow="Korean community guide"
      title="Korean favorites, businesses, and local essentials in San Antonio."
      
      tags={["Korean community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Korean community guide?"
      modalIdPrefix="korean-directory"
    />
  );
}
